export default __webpack_public_path__ + "static/assets/602d48da2d064c459699292f2fcccfbc.jpg";